import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import AnglePage from './pages/AnglePage';
import HeightPage from './pages/HeightPage';
import TorsionPage from './pages/TorsionPage';
import { PrivacyPage, TermsPage, ImpressumPage } from './pages/LegalPage';
import { RequireSession } from './components/RequireSession';

/* Native shell (Capacitor) detection.
 * The WKWebView serves the app from `capacitor://localhost`, so any
 * environment running under that scheme is the iOS app, not the web PWA.
 * In that mode the marketing landing page is dead weight — the user has
 * already installed and opened the app. Route them straight to /app and
 * keep the LandingPage available exclusively for the web (PWA / Safari)
 * surface, where it does its job. */
const isNativeShell =
  typeof window !== 'undefined' && window.location.protocol === 'capacitor:';

export default function App() {
  return (
    <Routes>
      {/* `/` is marketing on the web, but lands directly on the measurement
          surface inside the native iOS app. */}
      <Route
        path="/"
        element={isNativeShell ? <Navigate to="/app" replace /> : <LandingPage />}
      />
      {/* Legal pages stay public on both surfaces — Apple's App Review
          checks for reachable Privacy and Terms from inside the app. */}
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/impressum" element={<ImpressumPage />} />

      {/* App lives under /app/* — sign-in required. RequireSession
          renders a brand-aligned gate when the user isn't authenticated
          (or hasn't verified their email yet) and bounces through
          plan.cadtomie.com for the actual sign-in form. */}
      <Route
        path="/app"
        element={
          <RequireSession>
            <HomePage />
          </RequireSession>
        }
      />
      <Route
        path="/app/angle"
        element={
          <RequireSession>
            <AnglePage />
          </RequireSession>
        }
      />
      <Route
        path="/app/height"
        element={
          <RequireSession>
            <HeightPage />
          </RequireSession>
        }
      />
      <Route
        path="/app/torsion"
        element={
          <RequireSession>
            <TorsionPage />
          </RequireSession>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
